export const symbolMap: Record<string, string> = {
    USD: '$',
    EUR: '€',
    GBP: '£',
    JPY: '¥',
    CNY: '¥',
    RUB: '₽',
    INR: '₹',
    BRL: 'R$',
    UAH: '₴',
    KZT: '₸',
    BTC: '₿',
    AZN: '₼',
    ADR: 'Rp',
    AMD: '֏'
};
